var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#12A963"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0352 9.94828L11.443 15.6912C11.2689 15.8707 11.0513 15.9604 10.8338 15.9604C10.6162 15.9604 10.3768 15.8707 10.2245 15.6912L7.46106 12.8646C7.11291 12.5057 7.11291 11.9448 7.46106 11.5859C7.80921 11.227 8.35319 11.227 8.70134 11.5859L10.8338 13.7844L15.7949 8.66959C16.143 8.31066 16.687 8.31066 17.0352 8.66959C17.3615 9.02852 17.3615 9.61179 17.0352 9.94828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.33ea9fe53e5882f67f49618b4218958c.svg";
export { ForwardRef as ReactComponent };